__turbopack_context__.v({
  "blocksBackgroundColor": "ScrollHint-module-scss-module__IIbZRa__blocksBackgroundColor",
  "blocksFontColor": "ScrollHint-module-scss-module__IIbZRa__blocksFontColor",
  "row": "ScrollHint-module-scss-module__IIbZRa__row",
  "scrollButtons": "ScrollHint-module-scss-module__IIbZRa__scrollButtons",
  "scrollHint": "ScrollHint-module-scss-module__IIbZRa__scrollHint",
  "secondaryNavBackgroundColor": "ScrollHint-module-scss-module__IIbZRa__secondaryNavBackgroundColor",
  "themeBackgroundColor": "ScrollHint-module-scss-module__IIbZRa__themeBackgroundColor",
  "themeFontColor": "ScrollHint-module-scss-module__IIbZRa__themeFontColor",
});
